import React from "react";
import {
    CategoriaOuter,
    CategoriaInner,
} from "./style.js";
import Container from '../Layout/Container/index'
import PropTypes from "prop-types";
import Title from "../Layout/Title/index";
import Loading from '../Loading/index';

export default function Categoria({ categoria,loading }) {
    return (
        <>
            <Title>Categorias</Title>
            {
                loading ? (
                     <Loading text="Fetch categories"/>
                ):(
                    <Container width={"auto"} type={"repeat(auto-fit, minmax(350px, 1fr));"} justify={"center"} display={"grid"}>
                {categoria.map((categoria) => (
                    <CategoriaOuter
                        key={categoria._id}
                        img={"/svg/Roupas.jpg"}
                        to={`/categoria/${categoria._id}`}
                    >
                        <CategoriaInner>
                            {categoria.name}
                            <br />
                            <span>Ver mais</span>
                        </CategoriaInner>
                    </CategoriaOuter>
                ))}
            </Container>
                )
            }
        </>
    );
}

Categoria.propTypes = {
    categoria: PropTypes.array,
};
